export class Resolution {
  constructor(public readonly width: number, public readonly height: number, public readonly colorDepthInBit?: number) {}

  getDesc(): string {
    let tmp = this.width + " x " + this.height;
    if (this.colorDepthInBit !== undefined) tmp = tmp + " (" + this.colorDepthInBit + ")";
    return tmp;
  }

  toDropdownModel(): any {
      return {label: this.getDesc(), value: this};
  }
}

/** globally used function to sort Resolutions (for instance in Capabilities of Devices or Templates) */
export function resolutionSortingFunction(a: Resolution, b: Resolution){
  if (a.width !== b.width){
    return b.width - a.width;
  } else if (a.height !== b.height){
    return b.height - a.height;
  } else if (a.colorDepthInBit !== b.colorDepthInBit){
    return b.colorDepthInBit - a.colorDepthInBit;
  } else return 0;
}

export function resolutionFromBackendObject(r: any){
  return new Resolution(Number(r.width), Number(r.height)); /* we currently cut off the colorDepth */
}

